// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__tDZWy","name":"ConsentHeader_name__184-_","birthday":"ConsentHeader_birthday__1NSV1","skeleton":"ConsentHeader_skeleton__1S5st"};